enum SearchSource {
  ApplyFilters = 'ApplyFilters',
  Composer = 'Composer',
  DefaultSuggestion = 'DefaultSuggestion',
  Facet = 'Facet',
  Favorites = 'Favorites',
  InitialPageLoad = 'InitialPageLoad',
  Location = 'Location',
  Pagination = 'Pagination',
  RecentSearch = 'RecentSearch',
  SavedSearch = 'SavedSearch',
  SortBy = 'SortBy',
  SuggestedFilter = 'SuggestedFilter',
  TagRemoved = 'TagRemoved',
  TextSearch = 'TextSearch',
  Tile = 'Tile'
}

export default SearchSource;
